import * as React from 'react';
import { ISeedProduct, ISeedAttributeValue, IDocument } from 'src/infrastructure/interfaces';
import { SeedCategory } from 'src/infrastructure/enums';
import './TypeSeedBarChart.css';

export interface ITypeSeedBarChart {
  product: ISeedProduct;
  document?: IDocument;
}

export interface IBarConfig {
  name?: string
  value: string[],
}

export default class TypeSeedBarChart extends React.Component<ITypeSeedBarChart> {
  categoryAttributes: IBarConfig[];

  constructor(props: ITypeSeedBarChart) {
    super(props);

    this.categoryAttributes = this.attributesPerCategory(this.props.product.category.id);
  }

  

  render() {
    const displayAttributes: IBarConfig[] = this.categoryAttributes.filter((bar: IBarConfig, index: number) => {
      return this.onlyNumbers(bar, index);
    });

    const docType = this.props.document ? this.props.document.type : "";

    return (
      <div className={`bar-chart row-count-${displayAttributes.length}`}>
        {displayAttributes.map((bar: IBarConfig, index: number) => {
          const value = this.attributeValue(bar.value);
          return (
            <div className={`${docType}  bar-attribute ${index % 2 === 0 ? 'odd' : 'even'}`} key={index}>
              <div className={`${docType} bar-name`}>
                {bar.name || this.attributeName(bar.value)}{Number(value) <= 0 && ' - N/A'}
              </div>
              <div className="bar-value" style={{ width: `${Number(value)/9*100}%` }}></div>
            </div>
          );
        })}
        <div className={`${docType} scale`}>
          <div>1</div>
          <div>2</div>
          <div>3</div>
          <div>4</div>
          <div>5</div>
          <div>6</div>
          <div>7</div>
          <div>8</div>
          <div>9</div>
        </div>
      </div>
    );
  }

  attributesPerCategory(categoryId: number): IBarConfig[] {
    switch (categoryId) {
      case SeedCategory.Alfalfa:
        return [
          { value: ['RecoveryAfterCutting'] },
          { value: ['PersistenceIndex'] },
          { value: ['ForageQuality'] },
          { value: ['AphanomycesRating'] },
          { value: ['PhytophthoraRootRotRating'] },
          { value: ['AnthracnoseRating'] },
          { value: ['VerticilliumWiltRating'] },
          { value: ['FusariumWiltRating'] },
          { value: ['BacterialWiltRating'] },
        ];
      case SeedCategory.Corn:
        return [
          { value: ['RootStrength'] },
          { value: ['StalkStrength'] },
          { value: ['Staygreen'] },
          { value: ['DroughtTolerance'] },
          { value: ['TestWeight'] },
          { value: ['Drydown'] },
        ];
      case SeedCategory.Sunflower:
        return [
          { value: ['YieldPotential'] },
          { value: ['AverageOilPercentage'] },
          { value: ['Selfcompatibility'] },
          { value: ['StalkQuality'] },
          { value: ['Rooting'] },
          { value: ['Rust'] },
          { value: ['PhomaBlackStem'] },
        ];
      case SeedCategory.SoftRedWinterWheat:
        return [
          { value: ['StrawStrength'] },
          { value: ['TestWeight'] },
          { value: ['HessianFly'] },
          { value: ['StripeRust'] },
          { value: ['PowderyMildew'] },
          { value: ['SeptoriaLeafBlotch'] },
          { value: ['FusariumHeadScab'] },
        ];
      case SeedCategory.Silage:
        return [
          { value: ['RootStrength'] },
          { value: ['StalkStrength'] },
          { value: ['Staygreen'] },
          { value: ['DroughtTolerance'] },
          { value: ['GreensnapRisk'] },
          { value: ['MilkAcre'] },
        ];
      case SeedCategory.ForageSorghum:
      case SeedCategory.SudangrassSorghum:
        return [
          { value: ['RelativeFeedValue'] },
          { value: ['Leafy'] },
          { value: ['StalkStrength'] },
          { value: ['EarlyVigor'] },
          { value: ['Dryland'] },
          { value: ['IrrigatedEnvironment'] },
          { value: ['YieldUnderStress'] },
          { value: ['TonnagePotential'] },
        ];
      case SeedCategory.GrainSorghum:
        return [
          { value: ['EarlyVigor'] },
          { value: ['Standability'] },
          { value: ['HeadExertion'] },
          { value: ['Threshability'] },
          { value: ['DroughtTolerance'] },
          { value: ['HeatTolerance'] },
          { value: ['Anthracnose'] },
          { value: ['SugarcaneAphid'] },
        ];
      case SeedCategory.SoybeansOver3_5RM:
        return [
          { value: ['Emergence'] },
          { value: ['Standability'] },
          { value: ['ShatterResistance'] },
          { value: ['StressTolerance'] },
          { value: ['FrogeyeLeafSpot'] },
          { value: ['PhytophthoraFieldTolerance'] },
          { value: ['SuddenDeathSyndrome'] },
          { value: ['IronDeficiencyChlorosis'] },
        ];
      case SeedCategory.SoybeansUnder3_5RM:
        return [
          { value: ['Emergence'] },
          { value: ['Standability'] },
          { value: ['ShatterResistance'] },
          { value: ['StressTolerance'] },
          { value: ['BrownStemRot'] },
          { value: ['PhytophthoraFieldTolerance'] },
          { value: ['SclerotiniaWhiteMold'] },
          { value: ['IronDeficiencyChlorosis'] },
        ];
      case SeedCategory.HardRedSpringWheat:
        return [
          { value: ['StrawStrength'] },
          { value: ['TestWeight'] },
          { value: ['Protein'] },
          { value: ['LeafRust'] },
          { value: ['StripeRust'] },
          { value: ['FusariumHeadScab'] },
          { value: ['BacterialLeafStreak'] },
        ];
      case SeedCategory.HardRedWinterWheat:
        return [
          { value: ['StrawStrength'] },
          { value: ['TestWeight'] },
          { value: ['WinterHardiness'] },
          { value: ['LeafRust'] },
          { value: ['StripeRust'] },
          { value: ['TanSpot'] },
          { value: ['StemRust'] },
        ];
      case SeedCategory.SoftWhiteWinterWheat:
        return [
          { value: ['StrawStrength'] },
          { value: ['TestWeight'] },
          { value: ['StripeRust'] },
          { value: ['PowderyMildew'] },
          { value: ['SeptoriaLeafBlotch'] },
          { value: ['StagnosporaGlumeBlotch'] },
          { value: ['FusariumHeadScab'] },
        ];
      case SeedCategory.Rice:
        return [
        ];
      case SeedCategory.Mustard:
        return [
          { value: ['Yield'] },
          { value: ['Maturity'] },
          { value: ['Height'] },
          { value: ['BlackLeg'] },
          { value: ['White Rust'] }
        ];
      case SeedCategory.Barley:
        return [
          { value: ['Yield'] },
          { value: ['Maturity'] },
          { value: ['Lodging'] },
          { value: ['Height'] },
          { value: ['Test Weight'] },
          { value: ['Plump'] },
        ];
      case SeedCategory.DurumWheat:
        return [
          { value: ['Yield'] },
          { value: ['Maturity'] },
          { value: ['Lodging'] },
          { value: ['Height'] },
          { value: ['Test Weight'] },
          { value: ['Protein'] },
        ];
      case SeedCategory.Flax:
        return [
          { value: ['Yield'] },
          { value: ['Maturity'] },
          { value: ['Height'] },
        ];
      default:
        return [];
    }
  }

  attributeValue(name: string|string[], delimiter: string = ''): string {
    const {
      attributes,
    } = this.props.product;
    const value: string[] = [];
    const names: string[] = typeof name === 'string' ? [name] : name;
    attributes.forEach((attrData: ISeedAttributeValue) => {
      if (names.includes(attrData.attribute.name)) {
        value.push(attrData.value);
      }
    });
    return value.join(delimiter);
  }

  attributeName(name: string|string[]): string {
    const {
      attributes,
    } = this.props.product;
    let title = '';
    const findName: string = typeof name === 'string' ? name : name[0];
    attributes.forEach((attrData: ISeedAttributeValue) => {
      if (attrData.attribute.name === findName) {
        title = attrData.attribute.productDescriptionDisplayName ||
          attrData.attribute.agronomyChartDisplayName ||
          attrData.attribute.createSeedDisplayName;
      }
    });
    return title;
  }

  onlyNumbers(bar: IBarConfig, index: number): boolean {
    const value = this.attributeValue(bar.value);
    return !!value && !isNaN(Number(value));
  }
}



// WEBPACK FOOTER //
// ./src/components/Products/components/TypeSeedBarChart.tsx